import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import restService from "../rest-service/RestService";
import { IObjectRelationshipsModel } from "./Models";

const RelationshipsDataService = {
    getRelationships: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<IObjectRelationshipsModel> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/relationships`

        const response = await restService.get<IObjectRelationshipsModel>(path, signal);

        return response.data;
    }
}

export default RelationshipsDataService;